import { render } from "./RadarCharts.vue?vue&type=template&id=cd7e614a"
import script from "./RadarCharts.vue?vue&type=script&lang=js"
export * from "./RadarCharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__